import { type StructuredTextGraphQlResponse } from 'react-datocms';

export const cookieCategoryKeys = [
  'necessary',
  'preferences',
  'statistics',
  'marketing',
] as const;
export type CookieCategoryKey = (typeof cookieCategoryKeys)[number];

export type CookieCategory = {
  description: string;
  key: CookieCategoryKey;
  name: string;
};

export type CookieBannerText = {
  acceptAllButtonText: string;
  acceptSelectedButtonText: string;
  categories: CookieCategory[];
  declineButtonText: string;
  // DatoCMS will always have a description but could be empty from Cookiebot
  description?: StructuredTextGraphQlResponse;
  hideDetailsText: string;
  showDetailsText: string;
  title: string;
};
